module.exports = __webpack_public_path__ + "img/Dantam Hair 09B.c6b47604.jpg";